export default {
    namespaced: true,
    state () {
        return {
            loading: false,
            applied_filters: [],
            available_filters: {
                attributes: [],
                brands: [],
                categories: [],
                price: {},
            },
            links: {},
            meta: {},
            route: {
                brands: [],
                categories: [],
                gender: [],
                page: [],
                tag: [],
                title: [],
            },
            request: {
                brands: [],
                categories: [],
                attributes: [],
                min_price: null,
                max_price: null,
                order: null,
                page: null,
                stock_status: false,
                special_offers: false,
                trigger: 0
            },
            data: [],
            showFilters: false,
        }
    },
    mutations: {
        setResult (state, result) {
            state.applied_filters = [...result.applied_filters];
            state.available_filters = {
                attributes: [...result.available_filters.attributes],
                brands: [...result.available_filters.brands],
                categories: [...result.available_filters.categories],
                price: {...result.available_filters.price},
            };
            state.links = {...result.links};
            state.meta = {...result.meta};
            state.route = {
                brands: [...result.route.brands],
                categories: [...result.route.brands],
                gender: {...result.route.brands},
                page: result.route.page,
                tag: {...result.route.page},
                title: result.route.title,
            };

            state.applied_filters.map(applied_filter => {
                if (applied_filter.type === 'brand') {
                    //Set brands to request
                    applied_filter.filters.map(filter => {
                        state.request = {
                            ...state.request,
                            brands: [...state.request.brands, Number(filter.id)],
                        };
                    });
                } else if (applied_filter.type === 'attribute') {
                    //Set attributes to request
                    applied_filter.filters.map(filter => {
                        state.request = {
                            ...state.request,
                            attributes: [...state.request.attributes, Number(filter.entity_id)],
                        };
                    });
                } else if (typeof state.request[applied_filter.type] !== "undefined") {
                    //Set other simple filters to request
                    const newObject = {};
                    newObject[applied_filter.type] = applied_filter.filters;
                    state.request = {
                        ...state.request,
                        ...newObject
                    }
                }
            });
            state.data = [...result.data];
        },
        addBrand (state, brand) {
            state.request = {
                ...state.request,
                categories: [...state.request.categories],
                attributes: [...state.request.attributes],
                brands: [...state.request.brands, Number(brand)]
            };
        },
        removeBrand (state, brand) {
            state.request = {
                ...state.request,
                categories: [...state.request.categories],
                attributes: [...state.request.attributes],
                brands: [...state.request.brands.filter(_brand => {
                    return _brand !== Number(brand);
                })]
            };
        },
        addAttribute (state, attribute) {
            state.request = {
                ...state.request,
                categories: [...state.request.categories],
                brands: [...state.request.brands],
                attributes: [...state.request.attributes, Number(attribute)]
            };
        },
        removeAttribute (state, attribute) {
            state.request = {
                ...state.request,
                categories: [...state.request.categories],
                brands: [...state.request.brands],
                attributes: [...state.request.attributes.filter(_attribute => {
                    return _attribute !== Number(attribute);
                })]
            };
        },
        setFilterValue (state, payload) {
            const newObject = {};
            newObject[payload[0]] = payload[1];
            state.request = {
                ...state.request,
                ...newObject
            }
        },
        setPage (state, page) {
            state.request.page = page;
        },
        setLoading (state, loading) {
            state.loading = loading;
        },
        fireTrigger (state) {
            state.request.trigger = state.request.trigger + 1;
        },
        setShowFilters(state, showFilters) {
            state.showFilters = showFilters;
        }
    },
    getters: {

    }
}
